import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { describeImportRequestError } from "./articleImportErrors";

export async function requestArticleImportValidation(rows, signal) {
  try {
    const response = await axios.post(`${ApiLink.API_URL}ArticleImport/validate`, { Rows: rows }, { headers: authHeader(), signal, timeout: 60000 });
    return response.data;
  } catch (error) {
    if (signal?.aborted) throw error;
    throw new Error(describeImportRequestError(error, "Kontrolli i artikujve"));
  }
}

export async function fetchArticleImportSaveStatus() {
  const response = await axios.get(`${ApiLink.API_URL}ArticleImport/save-status`, { headers: authHeader(), timeout: 60000 });
  return response.data?.Enabled === true;
}

export async function requestArticleImportSave(payload, signal) {
  try {
    const response = await axios.post(`${ApiLink.API_URL}ArticleImport/save-batch`, payload, { headers: authHeader(), signal, timeout: 180000 });
    return response.data;
  } catch (error) {
    throw new Error(`${describeImportRequestError(error, "Ruajtja e artikujve")} Pjesa e fundit mund të jetë ruajtur pjesërisht. Riprovimi kontrollon artikujt ekzistues. Rreshtat me konflikt duhen kontrolluar te lista e artikujve; suksesi i tyre nuk mund të supozohet.`);
  }
}
